import MintNFTContainer from '../../containers/MintNFT';

const MintNFT = () => {

  return <MintNFTContainer />
}

export default MintNFT;

